module.exports = __webpack_public_path__ + "img/map_china.05b198cb.png";